import React from "react";
import { Grid} from "semantic-ui-react";
import { addItemsTabWarnings, deleteItemsTabWarnings } from '../../../commonActions/serverErrorAction';
import DropDown from "../../../commonComponents/formComponents/dropDown";
import InputField from "../../../commonComponents/formComponents/inputField";
import { getValidationError as ValidationError} from '../../Helper';

import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "../../../commonComponents/deleteIcon";
import CopyRepElement from "../../../GB_App/formSections/itemsTab/copyRepElement";
const PreviciousDocumentsDetails=({
  item:{code,class:Class,infoId,ref,merchandiseId},
  infoIndex,
  translate,
  updateItem,
  saveItem,
  deleteItem,
  copyData,
  isFormDisabled, 
  lineItemIndex,
  invoiceIndex}) => {

  const dispatch = useDispatch();
  const box40DocClass = useSelector((state) =>
    state.DropDownValues.box40DocClass   
  );

  const getValidationError=(field, value, Level, onlyMandatoryCheck)=>ValidationError(field, value, Level, onlyMandatoryCheck,'',translate)

  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }
 


  const box40DocType = useSelector(
    (state) => state.DropDownValues.box40DocType
  );


  return (
  
      <Grid.Row>
        <Grid.Column width={1} style={{textAlign:'center'}}>
          <CopyRepElement 
            title={`CARGO_PRECEEDINGS_DOCS`}
            request={{infoId:'', code, class:Class, ref, }}
            callback={copyData}
            isFormDisabled={isFormDisabled}
          />
        </Grid.Column>
        <Grid.Column
          width="5"
          className='divFormFeild border-bottom b-rw-0'
        >
          <DropDown
            id={`1degree-${merchandiseId}`}
            disabled={isFormDisabled}
            className="field-bg dropdown100 addInfoCode"
            labelClass="text-none"
            label={`1${"\u00b0"}`}
            boxNumber="40"
            isLabel={true}
            data={box40DocType}
            clearable
            errors={getValidationError('prevcode', code, 'itemsTab',true)}
            value={code}
            onChange={(value) => {
              updateItem(infoId,{code:value?.trim()})
              saveItem({infoId,code:value})
               let err = getValidationError('prevcode', value, 'itemsTab',true)
               err.length
                 ? addErrors(
                     'itemsTab',
                     `invoice - 00${invoiceIndex + 1} :: line 00${lineItemIndex + 1}.` +
                       ' :: ' +
                       err[0],
                     `prevcode-${merchandiseId}-${infoIndex}`
                   )
                 : deleteErrors('itemsTab', '', `prevcode-${merchandiseId}-${infoIndex}`)
            
            }}
          />
               
        </Grid.Column>
        <Grid.Column width="4" className="divFormFeild  border-bottom">
        <DropDown
            id={`2degree-${merchandiseId}`}
            disabled={isFormDisabled}
            className="field-bg dropdown100 addInfoCode"
            labelClass="text-none"
            label={`2${"\u00b0"}`}
            boxNumber="40"
            isLabel={true}
            data={box40DocClass}
            clearable
            errors={getValidationError('prevclass', Class, 'itemsTab',true)}
            value={Class}
            onChange={(value) => {
               updateItem(infoId,{['class']:value?.trim()})
               saveItem({infoId,['class']:value})
              let err = getValidationError('prevclass', value, 'itemsTab')
              err.length
                ? addErrors(
                    'itemsTab',
                    `invoice - 00${invoiceIndex + 1} :: line 00${lineItemIndex + 1}.` +
                      ' :: ' +
                      err[0],
                    `prevclass-${merchandiseId}-${infoIndex}`
                  )
                : deleteErrors('itemsTab', '', `prevclass-${merchandiseId}-${infoIndex}`)
            
            }}
          />
        </Grid.Column>
        <Grid.Column width="5" className="divFormFeild  border-bottom ">
          <InputField
            isLabel={false}
            id={`3degree-${merchandiseId}`}
            type="text"
            label={`3${"\u00b0"}`}
            errors={getValidationError('prevref', ref, 'itemsTab')}
            value={ref}
            className={"field-bg"}
            clearInput={false}
            disabled={isFormDisabled}
            onChange={(value) => {
              updateItem(infoId,{ref:value})
            }}
            onBlur={(value) => {
              saveItem({infoId,ref:value})
              let err = getValidationError('prevref',ref, 'itemsTab')
          err.length
          ? addErrors('itemsTab',`invoice - 00${invoiceIndex+1} :: line 00${lineItemIndex+1}.`+ " :: " +err[0]  , `prevref-${merchandiseId}-${infoIndex}`)
          : deleteErrors('itemsTab', '', `prevref-${merchandiseId}-${infoIndex}`)
            }}
          />
        </Grid.Column>

        <Grid.Column width={1} className="icon-delete-add-info">
      <DeleteIcon
       onClick={() =>deleteItem(infoId)} disabled={isFormDisabled} 
       />
      </Grid.Column>
      </Grid.Row>
   
  );
}

export default React.memo(PreviciousDocumentsDetails)
